// extracted by mini-css-extract-plugin
export var formContainer = "_k1-0";
export var message = "_k1-1";